import { render, staticRenderFns } from "./logoPiedPageImageUpload.vue?vue&type=template&id=2d15dc8c&"
import script from "./logoPiedPageImageUpload.vue?vue&type=script&lang=js&"
export * from "./logoPiedPageImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports